import { useMemo } from 'react';
export * from './useRecaptchaV3';
export * from './useGA4Tracking';

export const useAddTitleText = (title: string): string => useMemo(() => `Add ${title}`, [title]);
export const useUpdateTitleText = (title: string): string => useMemo(() => `Update ${title}`, [title]);
export const useAddLoadingText = (text: string): string => useMemo(() => `${text} is creating...`, [text]);
export const useUpdateLoadingText = (text: string): string => useMemo(() => `${text} is updated...`, [text]);
